<template>
  <div class="sidebar">
    <div class="sidebar-top">
      <FsTooltip
        class="tooltip"
        placement="right"
        v-for="item in sidebarListTop"
        :key="item.name"
        :id="item.menuId"
        :content="item.label"
        :popper-content-style="{
          color: '#fff',
          lineHeight: '22px',
        }"
        text
      >
        <RouterLink :to="item.path" class="sidebar-item" :class="{ _active: route.path.includes(item.path) }">
          <span :class="item.iconfontClass" :id="item.menuId"></span>
        </RouterLink>
      </FsTooltip>
    </div>
    <div class="sidebar-bottom">
      <FsTooltip
        class="tooltip"
        placement="right"
        v-for="item in sidebarListBottom"
        :key="item.name"
        :id="item.menuId"
        :content="item.label"
        :popper-content-style="{
          color: '#fff',
          lineHeight: '22px',
        }"
        text
      >
        <div v-if="item.action" @click="handleAction(item.action)" class="sidebar-item">
          <span :class="item.iconfontClass" :id="item.menuId"></span>
        </div>
        <RouterLink v-else :to="item.path" class="sidebar-item" :class="{ _active: route.path.includes(item.path) }">
          <span :class="item.iconfontClass" :id="item.menuId"></span>
        </RouterLink>
      </FsTooltip>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useUserStore } from '@/store/user'
import { useHeaderStore } from '@/store/header'
import { storeToRefs } from 'pinia'
import { FsTooltip } from 'fs-design'
import { handleFsLink } from '@/utils'
import { trackEvent } from '@/utils/analytics'

interface SidebarItem {
  name: string
  label: string
  path: string
  iconfontClass: string
  menuId: string
  action?: string
}

const route = useRoute()
const userStore = useUserStore()
const headerStore = useHeaderStore()
const { customersType } = storeToRefs(userStore)

// 处理侧边栏底部的动作
const handleAction = (action: string) => {
  switch (action) {
    case 'feedback':
      showFeedback()
      break
    case 'contact':
      contactClick()
      break
  }
}

// 显示反馈弹窗
const showFeedback = () => {
  trackEvent({
    eventCategory: 'dec_topology',
    eventAction: 'feedback_click',
    eventLabel: 'feedback',
  })
  headerStore.showFeedbackPopup()
}

// 联系我们
const contactClick = () => {
  trackEvent({
    eventCategory: 'dec_topology',
    eventAction: 'contactUs_click',
    eventLabel: 'contactUs',
  })
  window.open(handleFsLink('/product_and_project_inquiry.html'))
}
const sidebarListTop = ref<SidebarItem[]>([
  {
    name: '设计中心',
    path: '/design-center',
    iconfontClass: 'iconfont icon-tuobutu',
    label: 'Topology',
    menuId: 'DesignCenter',
  },
  {
    name: '产品清单',
    label: 'Product List',
    path: '/product-catalog',
    iconfontClass: 'iconfont icon-shebeiqingdan',
    menuId: 'ProductCatalog',
  },
  {
    name: '项目管理',
    label: 'Project Management',
    path: '/project',
    iconfontClass: 'iconfont icon-xiangmuguanli',
    menuId: 'ProjectManage',
  },
])

const sidebarListBottom = ref<SidebarItem[]>([
  {
    name: '联系我们',
    label: 'Contact Us',
    path: '#',
    iconfontClass: 'iconfont icon-a-contactus',
    menuId: 'ContactUs',
    action: 'contact',
  },
  {
    name: '反馈',
    label: 'Feedback',
    path: '#',
    iconfontClass: 'iconfont icon-feesback',
    menuId: 'Feedback',
    action: 'feedback',
  },
])

watch(
  () => customersType.value,
  newVal => {
    if (newVal === 'SUPER_ADMINISTRATOR') {
      // sidebarListTop.value.push({
      //   name: '模板管理',
      //   label: 'Template Management',
      //   path: '/template-manage',
      //   iconfontClass: 'iconfont icon-mobanguanli',
      //   menuId: 'TemplateManagement',
      // })
    }
  },
  {
    immediate: true,
  }
)
</script>

<style lang="scss" scoped>
.sidebar {
  width: 50px;
  height: 100%;
  padding: 16px 0;
  background-color: #fff;
  border-right: 1px solid #eee;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .sidebar-top,
  .sidebar-bottom {
    gap: 12px;
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .sidebar-item {
    display: flex;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    color: #19191a;
    transition: all 0.3s;

    &:hover {
      background: rgba(25, 25, 26, 0.04);
    }

    &._active {
      color: #4080ff;
      background: rgba(25, 25, 26, 0.04);
    }

    .iconfont {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      font-size: 20px;
      line-height: 1;
    }
  }
}
</style>
